(function ($) {
  var __ = {
    body: $('body'),
    window: $(window),
    // Scene Controller
    controller: window._animations.base.controller,
    global: window._animations.base,
    ajax: {},
    fetch: new ScrollMagic.Scene(),
    splitText: {},

    loadAnimations: function () {

      if (__.global.screen === "large") {
        __.splitText.page_title = __.global.splitText($('.pg-careers--title'));
        __.splitText.intro_text = __.global.splitText($('.pg-careers--introduction-content').find('p, h1,h2,h3,h4,h5,h6'));
        __.splitText.list_title = __.global.splitText($('.pg-careers-list--title'));
        
        
        /// Timeline
        var timeline = new TimelineMax();
        timeline.add(TweenMax.from('.pg-header--logo', 0.4, __.global.animations.fade.down), '+=1');
        timeline.add(TweenMax.from('.pg-navigation', 0.4, __.global.animations.slide.right));
        timeline.add(TweenMax.from('.pg-toggle--animation', 0.2, __.global.animations.fade.up), '+=0.2');
        timeline.add(TweenMax.from('.pg-careers--image', 0.4, __.global.animations.slide.left));
        timeline.add(TweenMax.from('.pg-header--social', 0.4, __.global.animations.fade.left));
        timeline.add(TweenMax.from($('.pg-careers--divider'), 0.2, { width: 0 }));
        __.global.staggerDisplay( __.splitText.page_title, timeline);

        timeline.add(TweenMax.from('.pg-careers--introduction-content', 0.2, __.global.animations.fade.up, 0));
        __.global.staggerDisplay( __.splitText.intro_text, timeline);
        __.global.staggerDisplay( __.splitText.list_title, timeline);

        timeline.staggerFrom($('.pg-job'), 0.4, __.global.animations.slide.up, 0.4);

        timeline.call(function () {
          __.global.completeLoadInAnimation();
          __.splitText.page_title.revert();
          __.splitText.intro_text.revert();
          __.splitText.list_title.revert();
        })
        .add(TweenMax.from('.pg-careers--carousel', 0.2, __.global.animations.fade.up, 0));
        timeline.play();

      }else{
          __.global.completeLoadInAnimation();
       
      }
    },

    scrollAnimations: function () {

    },

    // Function to call to setup functionality
    setup: function () {
      __.loadAnimations();
      __.scrollAnimations();
    }
  };
  // Attach Toolbox to window //
  if (typeof window._animations === "undefined") {
    window._animations = {};
  }
  window._animations.careers = __;
})(jQuery); // Fully reference jQuery after this point.
